let activeEl: HTMLElement | null = null;
let activeTimer: ReturnType<typeof setTimeout> | null = null;
let activeFadeTimer: ReturnType<typeof setTimeout> | null = null;

const VISIBLE_MS = 1500;
const FADE_MS = 200;

export function showToast(message: string, variant: 'success' | 'error' = 'success'): void {
  if (activeEl) {
    activeEl.remove();
    activeEl = null;
  }
  if (activeTimer) {
    clearTimeout(activeTimer);
    activeTimer = null;
  }
  if (activeFadeTimer) {
    clearTimeout(activeFadeTimer);
    activeFadeTimer = null;
  }

  const el = document.createElement('div');
  el.className = variant === 'error' ? 'toast toast-error' : 'toast';
  el.setAttribute('role', 'status');
  el.setAttribute('aria-live', 'polite');
  el.textContent = message;
  document.body.appendChild(el);
  activeEl = el;

  requestAnimationFrame(() => el.classList.add('toast-show'));

  activeTimer = setTimeout(() => {
    el.classList.remove('toast-show');
    el.classList.add('toast-hide');
    activeFadeTimer = setTimeout(() => {
      el.remove();
      if (activeEl === el) activeEl = null;
    }, FADE_MS);
  }, VISIBLE_MS);
}
